import React from 'react'
import { Link } from 'react-router-dom'
import SuperUserHomePageUI from '../../../templates/SuperUserHomePageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import CardUI from '../../../widgets/layout/CardUI.js'
import './StandingInstructionReport.css'

const StandingInstructionReportPageUI = ({ context, errorList, standingInstructionList, loading, onRefreshClick }) =>
  <SuperUserHomePageUI context={context} className='pg_su_standing_instruction_report' topnav='accounts'
    headerText='Standing Instruction Report' centered={loading} page='standingInstructionReport' dimension="w1600"
  >
    {
      loading &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      standingInstructionList &&
      <div>
        <LRTableActionsUI location='top'
          left={
            <span className='g_flex_left g_flex_h'>
              <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
              <span className='g_m_left_100 g_large'><b>Standing Instruction Report</b></span>
            </span>
          }
          right={<span />}
        />
        {
          standingInstructionList.length > 0 &&
          <StandingInstructionTableUI standingInstructionList={standingInstructionList} />
        }
        {
          standingInstructionList.length === 0 &&
          <span className='g_text_centre'>No standing instructions found</span>
        }
      </div>
    }
  </SuperUserHomePageUI>

const StandingInstructionTableUI = ({ standingInstructionList }) =>
  <CardUI>
    <table>
      <thead>
        <tr>
          <th>Account Name</th>
          <th>Beneficiary Name</th>
          <th>Bank Account Number</th>
          <th>IFSC Code</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Amount</th>
        </tr>
      </thead>
      <tbody>
        {
          standingInstructionList && standingInstructionList.map((standingInstruction, i) =>
            <tr key={i}>
              <td>
                <Link to={`/su/accounts/${standingInstruction.accountId}/recurringTransfers`}>
                  {standingInstruction.accountName || '-'}
                </Link>
              </td>
              <td>{standingInstruction.vendorName || '-'}</td>
              <td>{(standingInstruction.vendor && standingInstruction.vendor.bankAccountNumber) || '-'}</td>
              <td>{(standingInstruction.vendor && standingInstruction.vendor.bankIFSCCode) || '-'}</td>
              <td>{standingInstruction.startDateISO || '-'}</td>
              <td>{standingInstruction.endDateISO || '-'}</td>
              <td>{standingInstruction.paymentAmountF2 || '-'}</td>
            </tr>
          )
        }
      </tbody>
    </table>
  </CardUI>

export default StandingInstructionReportPageUI

